(function($) {
  "use strict";

  jQuery(document).ready(function(){



    /* Match Heigh   
        $('.item').matchHeight(); 
  */

    
    $(".do-nicescrol").niceScroll();
    
    
    

  });
  
})(jQuery);

document.addEventListener('DOMContentLoaded', function () {
  function moveFreeShippingBar() {
    const appBlock = document.querySelector(
      '[id*="essential_free_shipping_app_block"]'
    );

    if (!appBlock) return;

    const buyNowBtn = document.querySelector('.shopify-payment-button');
    const addToCartArea =
      document.querySelector('.action-buttons') ||
      document.querySelector('.product-form__buttons') ||
      document.querySelector('.product-form-buttons');

    const target = buyNowBtn || addToCartArea;

    if (!target) return;

    if (target.nextElementSibling !== appBlock) {
      target.insertAdjacentElement('afterend', appBlock);
    }
  }

  moveFreeShippingBar();
  setTimeout(moveFreeShippingBar, 500);
  setTimeout(moveFreeShippingBar, 1200);
  setTimeout(moveFreeShippingBar, 2000);
});